import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ClubModel, CourtBookingInfoModel, CourtBookingInfoPlayerModel } from '@bayclubs/court-booking-employee-api';

@Component({
    selector: 'app-player-info',
    templateUrl: './player-info.component.html',
    styleUrls: ['./player-info.component.scss'],
    standalone: false
})
export class PlayerInfoComponent implements OnInit {
    @Input() player: CourtBookingInfoPlayerModel;
    @Input() courtBooking: CourtBookingInfoModel;
    @Input() club: ClubModel;
    @Output() playerChanged: EventEmitter<boolean> = new EventEmitter();
    constructor() { }

    ngOnInit(): void { }

    onPlayerChanged() {
        this.playerChanged.emit(true);
    }
}
